// extracted by mini-css-extract-plugin
module.exports = {"checkList":"CheckList_checkList__A6Qzp","small":"CheckList_small__779ej","icon":"CheckList_icon__Mf5aN"};